import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import { addAnimationToSprite, MM_ANIMATIONS } from '../AnimationManager';
import LocalizationSoundAssetKeys from '../Localization-SoundAssetKeys';
import MarbleDisplay from '../mmcommon/MarbleDisplay';
import { playTitleJingle } from '../SoundManager';
import UIAssetKeys from '../UIAssetKeys';
import RoundSelectScreen from './RoundSelectScreen';

export default class IntroScreen extends Phaser.Scene {
  static get KEY() { return 'IntroScreen'; }

  constructor() {
    super({ key: IntroScreen.KEY });

    this.marbleInfo = [{ x: 100, y: 400, type: 1, speed: 1200 },
      { x: 155, y: 470, type: 2, speed: 1520 },
      { x: 250, y: 420, type: 3, speed: 1500 },
      { x: 312, y: 540, type: 4, speed: 1480 },
      { x: 700, y: 520, type: 5, speed: 1380 },
      { x: 810, y: 475, type: 1, speed: 1250 },
      { x: 900, y: 540, type: 3, speed: 1600 }];
  }

  init() {
    this.bg = null;
    this.animatedMarbles = null;

    this.penguinContainer = null;
    this.btnGo = null;
    this.penguin = null;
  }

  create() {
    this.bg = this.add.image(0,0,'introbackground').setOrigin(0);

    // Penguin coming in from side on ball
    this.penguinContainer = this.add.container();
    this.penguin = this.add.sprite(0,0,ABCyaPhaser.Images.DEFAULT_ATLAS);
    addAnimationToSprite(this.penguin, MM_ANIMATIONS, 'intro run', true, true);
    addAnimationToSprite(this.penguin, MM_ANIMATIONS, 'intro idle', false, true);

    this.btnGo = ABCyaPhaser.Images.addImage(10,this.penguin.height, UIAssetKeys._mm_common_assets_BtnGo, this).setOrigin(0)
      .once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.goClick, this);

    // Set up penguin roll in
    this.penguinContainer.add(this.btnGo);
    this.penguinContainer.add(this.penguin);

    this.makeMarbles();
    this.penguinContainer.alpha = 0;

    this.layoutRatio();

    this.time.delayedCall(10, this.startIntro, null, this);

    playTitleJingle(this);
  }

  goClick () {
    this.btnGo.disableInteractive();
    const count = this.marbleInfo.length;
    for (let i = 0; i < count; i++) {
      const marble = this.animatedMarbles[i];
      this.tweens.killTweensOf(marble);
      ABCyaPhaser.Tweens.addTween(marble, 750, { x: -500 }, Phaser.Math.Easing.Quadratic.In);
    }
    this.penguin.play('intro run');
    ABCyaPhaser.Tweens.addTween(this.penguinContainer, 750, { x: -500 }, Phaser.Math.Easing.Quadratic.In, () => this.introFinished());
  }

  introFinished() {
    this.scene.start(RoundSelectScreen.KEY);
  }

  makeMarbles () {
    // Make marbles
    this.animatedMarbles = [];
    const count = this.marbleInfo.length;
    for (let i = 0; i < count; i++) {
      const marble = new MarbleDisplay(this, this.marbleInfo[i].type);
      const item = this.add.container();
      const shadow = ABCyaPhaser.Images.addImage(0,0, UIAssetKeys._mm_common_assets_MarbleShadow, this).setOrigin(0);

      shadow.x = -18;
      shadow.y = marble.getBounds().height / 2 + 10;
      item.add(shadow);
      item.add(marble);
      item.x = this.scale.width + 50;
      item.y = this.marbleInfo[i].y - 20;
      this.animatedMarbles.push(item);
      ABCyaPhaser.Tweens.addTween(item, this.marbleInfo[i].speed, { x: this.marbleInfo[i].x }, Phaser.Math.Easing.Quadratic.Out);
    }
  }

  startIntro () {
    this.layoutRatio();
    this.penguinContainer.alpha = 1;
    this.penguinContainer.x = this.scale.width + 500;
    const centerx = this.scale.width / 2 - this.btnGo.width / 2;
    ABCyaPhaser.Tweens.addTween(this.penguinContainer, 2200, { x: centerx }, Phaser.Math.Easing.Quadratic.Out, () => this.handleGoReady());
    const count = this.marbleInfo.length;
    for (let i = 0; i < count; i++) {
      const marble = this.animatedMarbles[i];
      marble.x = this.scale.width + 50;
      marble.y = this.marbleInfo[i].y - 20;
      ABCyaPhaser.Tweens.addTween(marble, this.marbleInfo[i].speed, { x: this.marbleInfo[i].x }, Phaser.Math.Easing.Quadratic.Out);
    }
  }

  handleGoReady () {
    this.penguin.play('intro idle');

    ABCyaPhaser.Audio.playOneShot(LocalizationSoundAssetKeys._marblemath, this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);
    ABCyaPhaser.Tweens.addTween(this.btnGo, 500, { scale: 1 }, Phaser.Math.Easing.Back.Out, () => this.btnGo.setInteractive());
  }

  layoutRatio () {
    const pBuffer = 120;

    this.penguinContainer.y = this.scale.height - this.penguinContainer.getBounds().height - pBuffer;
    const count = this.animatedMarbles.length;
    for (let i = 0; i < count; i++) {
      const m = this.animatedMarbles[i];
      const r = Phaser.Math.Between(50, 150);
      m.y = this.scale.height - m.getBounds().height - r;
    }
  }
}